import React from 'react';
import clsx from 'clsx';
import HoverActionButtons from './buttons/HoverActionButtons';
import TabHeader from './tabs/TabHeader';
import SystemFlag from './SystemFlag';

const HoverActionHeader = ({
  canEdit,
  className,
  disabled,
  icon,
  isSystem,
  renderSystemFlag = () => <SystemFlag />,
  showEdit,
  value,
}) => (
  <HoverActionButtons
    canEdit={canEdit}
    disabled={disabled}
    editCopyMods="header"
    showEdit={showEdit}
    toolTip="bottom right"
    value={value}
  >
    <TabHeader
      className={clsx('aridhia-hover-action-header', className)}
      headerText={value}
      icon={icon}
      isSystem={isSystem}
      renderSystemFlag={renderSystemFlag}
    />
  </HoverActionButtons>
);

export default HoverActionHeader;
